/* eslint-disable  */

import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import ExitButton from 'components/button/ExitButton';
import comptroller from 'assets/images/comptroller_white.svg';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import EditableMonthTable from './EditableTable';
import { constantFormValues } from '../../../root';
import ExcelUploadModal from '../Excel/ExcelUploadModal';
import excel from 'assets/images/icons/excel.svg';

const TableContentModal = ({ icon, showModal, setShowModal, modalData = {}, formListName, form, numberOfColumn = 3, onDataSave = null }) => {
	const theme = useTheme();
	const [totalRow, setTotalRow] = React.useState(0);
	const [startMonth, setStartMonth] = React.useState('');
	const [excelModalVisible, setExcelModalVisible] = React.useState(false);

	// Track existing data
	const [existingData, setExistingData] = React.useState(null);

	const handleClose = () => {
		setShowModal(false);
	};

	const handleSubmit = () => {
		// Get the current form data from the modal
		const modalFormData = form.getFieldValue(formListName);
		// console.log('Modal form data to be saved:', modalFormData);

		if (modalFormData) {
			try {
				// Process data for API submission
				if (numberOfColumn === 3) {
					// Extract values from grossRent modal and format as an array of numbers
					const grossRentsArray = modalFormData.map((item) => (item.value ? parseFloat(item.value) : 0));

					// Store in form with the correct API field name
					form.setFieldValue('grossRents', grossRentsArray);
					// console.log('Saved grossRents array:', grossRentsArray);
				} else {
					// Extract values from advanceAmount modal and format as an array of numbers
					const advanceAmountsArray = modalFormData.map((item) => (item.advanceAdjustment ? parseFloat(item.advanceAdjustment) : 0));

					// Store in form with the correct API field name
					form.setFieldValue('advanceAmounts', advanceAmountsArray);
					// console.log('Saved advanceAmounts array:', advanceAmountsArray);
				}

				// Call the callback if provided
				if (onDataSave) {
					onDataSave(numberOfColumn === 3 ? 'grossRents' : 'advanceAmounts');
				}
			} catch (error) {
				console.error('Error formatting modal data for API:', error);
			}
		}

		setShowModal(false);
	};

	// Load lease data when the modal opens
	React.useEffect(() => {
		if (showModal) {
			// Get lease term and start date
			const leaseTermValue = form.getFieldValue(constantFormValues?.leaseTerm?.key);
			const startDateValue = form.getFieldValue(constantFormValues?.leaseStartDate?.key);

		

			// Set local state
			if (leaseTermValue) {
				setTotalRow(parseInt(leaseTermValue));
			}

			if (startDateValue) {
				setStartMonth(startDateValue.format('DD-MM-YYYY'));
			}

			// Check for existing form data
			if (numberOfColumn === 3) {
				// For grossRent modal, check grossRents field
				const existingGrossRents = form.getFieldValue('grossRents');
				if (existingGrossRents && Array.isArray(existingGrossRents)) {
					// Format existing data for the table
					const formattedData = existingGrossRents.map((value) => ({ value: value.toString() }));
					setExistingData(formattedData);

					// Also set the form list data
					form.setFieldValue(formListName, formattedData);
					// console.log('Loaded existing grossRents data:', formattedData);
				}
			} else {
				// For advanceAmount modal, check advanceAmounts field
				const existingAdvanceAmounts = form.getFieldValue('advanceAmounts');
				if (existingAdvanceAmounts && Array.isArray(existingAdvanceAmounts)) {
					// Format existing data for the table
					const formattedData = existingAdvanceAmounts.map((value) => ({
						advanceAmount: '0', // We don't store this separately
						advanceAdjustment: value.toString(),
					}));
					setExistingData(formattedData);

					// Also set the form list data
					form.setFieldValue(formListName, formattedData);
					// console.log('Loaded existing advanceAmounts data:', formattedData);
				}
			}
		}
	}, [showModal, form, formListName, numberOfColumn]);

	// Handle Excel data being applied from the Excel modal
	const handleExcelDataApplied = (data) => {
		// console.log('Applying Excel data to form:', data);

		// Update the form with the Excel data
		form.setFieldValue(formListName, data);

		// Also update our local state
		setExistingData(data);
	};

	return (
		<React.Fragment>
			<Dialog
				fullWidth={true}
				maxWidth={'md'}
				open={showModal}
				keepMounted
				onClose={handleClose}
				aria-labelledby="draggable-dialog-title"
				sx={{ '& .MuiPaper-root': { borderRadius: '8px' } }}
			>
				<Box>
					<Grid
						container
						spacing={2}
						justifyContent="space-between"
						alignItems="center"
						sx={{ bgcolor: '#214689', borderBottom: `1px solid ${theme.palette.divider}` }}
					>
						<Grid item>
							<DialogTitle sx={{ color: 'common.white', display: 'flex', alignItems: 'center' }}>
								<img alt="in progress" src={icon ? icon : comptroller} width="18px" height="18px" style={{ marginRight: '8px' }} />
								{modalData?.head || (numberOfColumn === 3 ? 'Monthly Gross Rent Schedule' : 'Advance Amount Schedule')}
							</DialogTitle>
						</Grid>

						<Grid item sx={{ mr: 3 }}>
							<ExitButton handleClose={handleClose} />
						</Grid>
					</Grid>

					<DialogContent sx={{ pt: { xs: 3, md: 4 }, pb: { xs: 2, md: 3 } }}>
						{!totalRow || totalRow <= 0 || !startMonth ? (
							<Typography align="center" color="error" sx={{ my: 3 }}>
								Please set Lease Term and Lease Start Date before using this feature
							</Typography>
						) : (
							<EditableMonthTable
								totalRows={totalRow}
								startMonthStr={startMonth}
								formListName={formListName}
								form={form}
								numberOfColumn={numberOfColumn}
								existingData={existingData}
							/>
						)}
					</DialogContent>

					<DialogActions>
						{/* Excel import button on the left */}
						<Box sx={{ flexGrow: 1 }}>
							<Button
								onClick={() => setExcelModalVisible(true)}
								startIcon={<img src={excel} alt="excel" width={16} />}
								variant="outlined"
								disabled={!totalRow || totalRow <= 0 || !startMonth}
							>
								Excel
							</Button>
						</Box>

						{/* Cancel and Apply buttons on the right */}
						<Button onClick={handleClose} color="inherit">
							Cancel
						</Button>
						<Button onClick={handleSubmit} color="primary" variant="contained" disabled={!totalRow || totalRow <= 0 || !startMonth}>
							Apply
						</Button>
					</DialogActions>
				</Box>
			</Dialog>

			{/* Excel upload modal */}
			<ExcelUploadModal
				visible={excelModalVisible}
				onCancel={() => setExcelModalVisible(false)}
				onApply={handleExcelDataApplied}
				numberOfColumn={numberOfColumn}
				totalRows={totalRow}
				startMonthStr={startMonth}
			/>
		</React.Fragment>
	);
};

export default TableContentModal;
